import { useGetEmdAmount } from './useGetEmdAmount';
import { useListActiveOrderEmdAccessLinksQuery } from '../../../../../../../API/order/payments/EmdAccessCodeApi';
import { useMemo } from 'react';
import { UUID } from '../../../../../../../types/shared/UUID';
import { useParams } from 'react-router-dom';

export const useGetSetOfPreviousDepositorIds = (): Set<UUID> => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { emdAmount } = useGetEmdAmount();
  const { data: accessCodeResponses = [] } = useListActiveOrderEmdAccessLinksQuery(orderId, { skip: !emdAmount });
  return useMemo(
    () => new Set(accessCodeResponses.map((accessCodeResponse) => accessCodeResponse.depositor.id)),
    [accessCodeResponses]
  );
};
